import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { CartProvider } from "@/cart/CartContext";
import StorePage from "@/pages/StorePage";
import CartPage from "@/pages/CartPage";
import PaymentSuccessPage from "@/pages/PaymentSuccessPage";
import PaymentCancelPage from "@/pages/PaymentCancelPage";
import TrackPage from "@/pages/TrackPage";
import OrdersDashboardPage from "@/pages/OrdersDashboardPage";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <CartProvider>
          <Routes>
            <Route path="/" element={<StorePage />} />
            <Route path="/cart" element={<CartPage />} />
            <Route path="/payment/success" element={<PaymentSuccessPage />} />
            <Route path="/payment/cancel" element={<PaymentCancelPage />} />
            <Route path="/track" element={<TrackPage />} />
            <Route path="/dispatch-x9q7-41" element={<OrdersDashboardPage />} />
          </Routes>
          <Toaster position="bottom-right" theme="dark" />
        </CartProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
